import React from 'react';
import moment from 'moment';

import BaseComponent from 'src/components/BaseComponent';
import { FileBox, SelectField, TextField } from 'src/components/basic';

import DefaultPdfImg from 'src/assets/images/default-pdf-img.png';

import { rangeToSelectList, remCss } from 'src/helpers';

import model from './model';
import constants from 'src/constants';
import AlertManager from 'src/components/alert';
import LANG_CONST from 'src/helpers/lang/const';

const apiId = 'update';

class CertificateFiles extends BaseComponent {
  containerRef = null;
  state = { colAmount: 8 };

  componentDidMount() {
    this.addListenWidthWindow();
    this.updateWidthWindow();
  }

  componentWillUnmount() {
    this.removeListenWidthWindow();
  }

  updateWidthWindow = () => {
    if (this.containerRef) {
      const dis = 380;
      let colAmount = Math.min(Math.ceil((this.containerRef.clientWidth - 40) / remCss(dis)), 3);
      if (colAmount !== this.state.colAmount) {
        this.setState({ colAmount });
      }
    }
  };
  input = (index, name, v) => {
    const certificateFiles = model.input('certificateFiles');
    model.resetApiState(apiId);
    const old = [...certificateFiles];
    old[index][name] = v;
    model.state.updatingData.push(old[index].counter);
    model.setState({
      certificateFiles: [...old],
      updating: true
    });
  };

  renderItem(item, index) {
    const year = moment().year();
    let { afterRemove, invalid, certificateFiles } = this.props;

    return (
      <>
        <FileBox
          template={1}
          list={certificateFiles}
          thumbnail={DefaultPdfImg}
          file={{ ...item }}
          onClose={() => {
            AlertManager.popup(AlertManager.TYPES.WARN, {
              close: false,
              title: LANG_CONST.notice.delete,
              cancelButton: {
                label: LANG_CONST.buttons.no,
                action: (actions) => actions.hide()
              },
              actionButton: {
                label: LANG_CONST.buttons.yes,
                action: (actions) => {
                  actions.setLoading(true);
                  model.remove(item, () => {
                    actions.hide();
                    actions.setLoading(false);
                    afterRemove && afterRemove();
                  });
                }
              }
            });
          }}
          showFileName={false}
          styles={{ height: remCss(180), width: '100%' }}
        />
        <TextField
          template={6}
          name={'certificate_title_' + index}
          placeholder={LANG_CONST.title}
          value={item.title}
          onChange={(n, v) => {
            this.input(index, 'title', v);
          }}
          invalid={invalid}
        />
        <div className={'mc-flex-20'}>
          <div className={'mc-grow'}>
            <SelectField
              template={6}
              isClearable={false}
              options={constants.general.specialist}
              value={item.specialty}
              name={'specialty'}
              placeholder={LANG_CONST.speciality}
              onChange={(n, v) => {
                this.input(index, 'specialty', v);
              }}
            />
          </div>
          <SelectField
            template={6}
            isClearable={false}
            value={item.promotionYear}
            options={rangeToSelectList(year - 70, year, true)}
            onChange={(n, v) => {
              this.input(index, 'promotionYear', v);
            }}
            name={'promotionYear'}
            placeholder={LANG_CONST.year}
          />
        </div>
      </>
    );
  }

  render() {
    let { certificateFiles } = this.props;
    certificateFiles = model.sort(certificateFiles, { key: 'counter', desc: true });
    const itemNumber =
      Math.ceil(certificateFiles.length / this.state.colAmount) * this.state.colAmount;
    const rows = [];
    let row = [];

    for (let index = 0; index < itemNumber; index++) {
      const item = certificateFiles[index];
      if (item) {
        row.push(
          <div
            key={item.counter}
            data-testid='certificate-card'
            className={'mc-flex-20-col mc-grow'}
            style={{ order: index }}
          >
            {this.renderItem(item, index)}
          </div>
        );
      } else {
        row.push(
          <div key={index} className={'mc-flex-20-col mc-grow'} style={{ order: index }}></div>
        );
      }
      if (row.length === this.state.colAmount) {
        rows.push(
          <div
            key={'rows-' + rows.length}
            className={'mc-flex-20 mc-flex-start ' + (rows.length !== 0 ? 'mc-b2t mc-pt25' : '')}
          >
            {row}
          </div>
        );
        row = [];
      }
    }

    return (
      <div className={'mc-flex-20-col'} ref={(ref) => (this.containerRef = ref)}>
        {rows}
      </div>
    );
  }
}

export default CertificateFiles;
